import styles from './ProductCard.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Product } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink } from 'src/components/ContentLink/ContentLink';
import { Blurb } from 'src/components/Contentful/Blurb';
import { EnhancedMedia } from 'src/components/EnhancedMedia/EnhancedMedia';
import { getField, isEntry } from 'src/utils/EntryUtil';

export interface IProductCard extends React.AllHTMLAttributes<HTMLLIElement> {
  entry?: ReferencedEntry<Product>;
  active?: boolean;
  large?: boolean;
}

export const ProductCard: React.FC<IProductCard> = ({
  className,
  entry,
  active,
  large,
  ...props
}) => !isEntry(entry) ? null : (
  <li
    className={cx(styles.productCard, className, {
      [styles.productCardLarge]: large,
    })}
    {...props}
  >
    <ContentLink className={styles.link} tabIndex={active ? undefined : -1} hideTitle alwaysRenderChildren entry={entry}>
      <div className={styles.textWrapper}>
        <h4 className={styles.title}>{getField(entry, 'title')}</h4>
        <Blurb className={styles.blurb} entry={entry} field="blurb" />
      </div>
      <EnhancedMedia className={styles.image} entry={entry} preferHeight />
    </ContentLink>
  </li>
);
